import script from "./GameBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./GameBoard.vue?vue&type=script&setup=true&lang=js"

import "./GameBoard.vue?vue&type=style&index=0&id=49a873b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a873b0"]])

export default __exports__